import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Checkbox from '@bibliocommons/base-checkbox';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { FormattedMessage } from 'react-intl';

import './BatchActionsListItem.scss';

const srCheckboxLabel = () => (
  <ScreenReaderMessage>
    <FormattedMessage id="batch_actions_checkbox" />
  </ScreenReaderMessage>
);

export default function BatchActionsListItem({ actionItem, updateItem, selectedItems, children }) {
  const id = actionItem.get('id');
  const selected = selectedItems.has(id);

  return (
    <div className="cp-batch-actions-list-item">
      <Checkbox
        label={srCheckboxLabel()}
        id={`batch-actions-list-item-checkbox-${id}`}
        inline
        handleChange={() => updateItem(actionItem)}
        value={id}
        checked={selected} />
      <div className="batch-actions-list-item-details">{children}</div>
    </div>
  );
}

BatchActionsListItem.propTypes = {
  actionItem: ImmutablePropTypes.map.isRequired,
  selectedItems: ImmutablePropTypes.map.isRequired,
  updateItem: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};



// WEBPACK FOOTER //
// ./app/components/shared/BatchActions/BatchActionsListItem/BatchActionsListItem.jsx